var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.env !== 'prod')?_c('v-container',{staticClass:"pa-0 ma-0",staticStyle:{"height":"40px"}},[_c('div',{staticClass:"env-bar",style:(_vm.envBarStyle)},[_vm._v(_vm._s(_vm.formattedEnv))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }